import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RestrictPlanService } from '../../restrict-plan.service';
import { GlobalApiService } from 'src/app/shared-modules/global-api.service';
@Component({
  selector: 'fyt-plan-restrict',
  templateUrl: './plan-restrict.component.html',
  styleUrls: ['./plan-restrict.component.css']
})
export class PlanRestrictComponent implements OnInit {
  showModal: boolean = false;  // Controls modal display
  localStorage: any;
  constructor(
    private restrictPlanService: RestrictPlanService,
    private globalApiService: GlobalApiService
  ) {

    this.localStorage = JSON.parse(localStorage.getItem('userDetails'))
  }

  ngOnInit(): void {
    this.restrictPlanService.restrictionEvent.subscribe((isRestricted) => {
      this.showModal = isRestricted;
    });



  }
  // Close Modal
  closeModal() {
    this.showModal = false;
  }

  // Apply CSS blur effect if feature is restricted
  getButtonClass(featureKey: string): string {
    return this.restrictPlanService.isFeatureRestricted(featureKey) ? 'blur-button' : '';
  }

  //  checkAccesss(): void {
  //   console.log("checkAccesss------------");
  //   if (this.userPlan !== 'Premium') {
  //     // If the user is not on the required plan, show the modal
  //     this.functionFlag = true;
  //     this.closeModal.emit({ access: false });
  //   } else {
  //     // If the user has the correct plan, allow access
  //     this.closeModal.emit({ access: true });
  //     alert("Access Granted")
  //     this.functionFlag = false
  //   }
  // }

  // closeDialog(){
  //   this.functionFlag = false
  // }

  navigateToPlan() {
    this.closeModal()
window.open(`${this.globalApiService.getPlansUrl()}${this.localStorage.adminUserId}/${this.localStorage.centreName}/${this.localStorage.centreId}`, '_blank');
    // window.open(`http://localhost:4200/plans/${this.localStorage.adminUserId}/${this.localStorage.centreName}/${this.localStorage.centreId}`, '_blank');
  }

  navigateToAddOn(){
    this.closeModal()
window.open(`${this.globalApiService.getPlansUrl().replace('/plans/', '/add-ons/')}${this.localStorage.adminUserId}/${this.localStorage.centreName}/${this.localStorage.centreId}`, '_blank');
    // window.open(`http://localhost:4200/add-ons/${this.localStorage.adminUserId}/${this.localStorage.centreName}/${this.localStorage.centreId}`, '_blank');
    console.log("navigateToAddOn", this.localStorage.adminUserId, this.localStorage.centreName, this.localStorage.centreId);
    
  }

}
